import * as React from 'react';
const classNames = require('classnames');

import Utils from '../../common/utils';

interface Props {
	children?: {} | null;
	className?: string;
	title?: string;
}

class Page extends React.Component<Props> {
	componentDidMount() {
		if (this.props.title || this.props.title === '') {
			Utils.setDocTitle(this.props.title);
		}
	}

	componentWillReceiveProps(nextProps: Props) {
		if (this.props.title !== nextProps.title) {
			Utils.setDocTitle(nextProps.title);
		}
	}

	render() {
		const { className, children } = this.props;
		return <article className={classNames('page-content', className)}>{children}</article>;
	}
}

export default Page;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/Page.tsx